import { Spinner } from "@climatepartner/components/Spinner";
import { ReactElement, Suspense } from "react";
import { Outlet } from "react-router-dom";

export { DocumentsPage } from "./lazy-pages";

export const DocumentsRoute = (): ReactElement => (
  <Suspense fallback={<Spinner />}>
    <Outlet />
  </Suspense>
);
